module.exports = __webpack_public_path__ + "static/media/linkedin.203ff559.svg";